<!-- 后续版本加上,目前无效 -->
<template>
  <el-form-item :label="i18nt('designer.setting.format')">
    <el-select v-model="optionModel.format" filterable allow-create @change="emitDefaultValueChange">
      <el-option label="YYYY" value="YYYY"></el-option>
      <el-option label="YYYY-MM" value="YYYY-MM"></el-option>
      <el-option label="YYYY-MM-DD" value="YYYY-MM-DD"></el-option>
      <el-option label="YYYY-M-D" value="YYYY-M-D"></el-option>
      <el-option label="YYYY/MM" value="YYYY/MM"></el-option>
      <el-option label="YYYY/MM/DD" value="YYYY/MM/DD"></el-option>
      <el-option label="YYYY/M/D" value="YYYY/M/D"></el-option>
      <el-option label="YYYY年" value="YYYY年"></el-option>
      <el-option label="YYYY年MM月" value="YYYY年MM月"></el-option>
      <el-option label="YYYY年MM月DD日" value="YYYY年MM月DD日"></el-option>
      <el-option label="YYYY年M月D日" value="YYYY年M月D日"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

import { useProperty } from '../propertyMixin';

export default {
  name: 'm-date-format-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const propertyMixin = useProperty();

    return {
      i18nt,
      ...propertyMixin,
      ...toRefs(props),
    };
  },
};
</script>

<style scoped></style>
